import React, { useEffect, useContext } from "react";
import useForm from 'react-hook-form';
import Select from "react-select";
import { useTranslation } from 'react-i18next';
import { MaskMonthYear } from "beaktShared/helpers/masks";

import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import { ValidSelect } from "beaktShared/helpers/validselect";

// icons
import DescriptionIcon from '@material-ui/icons/Description';
import "beaktShared/components/CustomInput/rotate.css";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";

import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";
import { MaskMoney, transformValueFloattoFormated, transformValueFormatedtoFloat } from "beaktShared/helpers/masks";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function IndiceEconomicoForm({ addItem, item, handleView, loading }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const session = useContext(SessionContext);

    const { register, handleSubmit, setValue, errors, getValues, setError, clearError } = useForm({ mode: "onBlur" });

    const [IndiceEconomicoId, setIndiceEconomicoId] = React.useState(0);
    const [isLoadingIndices, setisLoadingIndices] = React.useState(false);
    const [listSelectIndices, setlistSelectIndices] = React.useState([]);
    const [jsonIndice, setjsonIndice] = React.useState(null);

    const intialValues = {
        indiceEconomicoId: 0,
        indice: '',
        mesAno: '',
        valor: ''
    };

    const LoadSelectIndices = () => {
        setisLoadingIndices(true);
        const endPoint = "indiceEconomico/getTiposIndice";
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                setisLoadingIndices(false);
                return false;
            }
            setlistSelectIndices(result.data);
            setisLoadingIndices(false);
            return true;
        });
    };

    useEffect(() => {
        LoadSelectIndices();
    }, []);

    useEffect(() => {
        LoadDadosItem(item);
    }, [item]);

    const LoadDadosItem = (item) => {
        if (!item.indiceEconomicoId)
            return;

        setValue('indiceEconomicoId', (item.indiceEconomicoId === null ? 0 : item.indiceEconomicoId));
        setIndiceEconomicoId((item.indiceEconomicoId === null ? 0 : item.indiceEconomicoId));

        let idxVal = (item.indice !== undefined ? item.indice : item.tipoIndice);
        setValue('indice', idxVal);
        setjsonIndice(idxVal);

        setValue('mesano', item.mesAno);

        let valor = transformValueFloattoFormated(item.valor);
        setValue('valor', valor);
    };

    const onSubmit = (data, e) => {
        e.preventDefault();

        let val = transformValueFormatedtoFloat(data.valor);
        let objAdd = {
            indiceEconomicoId: (IndiceEconomicoId === null ? 0 : IndiceEconomicoId),
            indice: jsonIndice,
            mesAno: data.mesano,
            valor: val,
            usuarioCadastroId: session.id,
            dataCadastro: (item.dataCadastro ? item.dataCadastro : null),
        }

        addItem(objAdd);
    };

    const handleViewForm = () => {
        handleView();
    };

    return (
        <div className="maxContent">
            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer className={classes.marginTopCard}>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <DescriptionIcon />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    {t('label.economic_index_record') || "Cadastro de Índice Econômico"}
                                    <input className={classes.hidden} defaultValue={intialValues.indiceEconomicoId} name="indiceEconomicoId" ref={register} />
                                </h4>
                            </CardHeader>
                            <CardBody className={classes.cardMargin}>

                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <label className={errors.indice ? "select__label select__label_error" : "select__label"}>{(t('label.index') || "Índice") + " *"}</label>
                                            <Select
                                                classNamePrefix="select"
                                                styles={ValidSelect(errors.indice ? true : false)}
                                                isSearchable={true}
                                                isLoading={isLoadingIndices}
                                                isMulti={false}
                                                name="indice"
                                                placeholder={t('label.select') + "..."}
                                                options={listSelectIndices.map((val, index) => (typeof val === 'string' ? { label: val, value: val, index } : { label: val.indice || val.label, value: val.indice || val.value, index }))}
                                                value={listSelectIndices.map((val, index) => (typeof val === 'string' ? { label: val, value: val, index } : { label: val.indice || val.label, value: val.indice || val.value, index })).find(f => (jsonIndice !== null && jsonIndice !== '') && (f.value == jsonIndice || f.index == jsonIndice))}
                                                onChange={(item) => {
                                                    setjsonIndice(item.value);
                                                    setValue("indice", item.value);
                                                    if (item.value !== "")
                                                        clearError("indice");
                                                }}
                                                ref={() => register({ name: "indice", required: true })}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.indice && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.mesano ? true : false}
                                                variant="outlined"
                                                inputRef={register({ required: t('label.required') })}
                                                label={t('label.month_year') + " *"}
                                                name="mesano"
                                                InputProps={{ inputComponent: MaskMonthYear }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.mesano && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.valor ? true : false}
                                                label={t('label.value') + " *"}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                name="valor"
                                                defaultValue={intialValues.valor}
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{ inputComponent: MaskMoney }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.valor && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                <Clearfix />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>

                        <div className={classes.textCenter}>
                            <Button onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                                {t('button.cancel')}
                            </Button>
                            <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                {t('button.to_save')}
                                {loading && <div>...{t('label.loading')}</div>}
                            </Button>
                        </div>
                    </GridItem>
                </GridContainer>
            </form>
        </div>
    );
}